import { Suspense, lazy } from 'react'
import { ThemeProvider } from './context/ThemeContext'
import Navbar from './components/Navbar.tsx'
import Home from './components/Home.tsx'
import Footer from './components/Footer.tsx'
import ClickSpark from './components/ClickSpark.tsx'
import ScrollToTop from './components/ScrollToTop.tsx'

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'

const Blog = lazy(() => import('./components/Blog.tsx'))
const Careers = lazy(() => import('./components/Careers.tsx'))
const PrivacyPolicy = lazy(() => import('./components/PrivacyPolicy.tsx'))
const FAQ = lazy(() => import('./components/FAQ.tsx'))
const Documentation = lazy(() => import('./components/Documentation.tsx'))
const Services = lazy(() => import('./components/Services.tsx'))
const Portfolio = lazy(() => import('./components/Portfolio.tsx'))
const Process = lazy(() => import('./components/Process.tsx'))
const WhyChooseUs = lazy(() => import('./components/WhyChooseUs.tsx'))
const Pricing = lazy(() => import('./components/Pricing.tsx'))
const Testimonials = lazy(() => import('./components/Testimonials.tsx'))
const Contact = lazy(() => import('./components/Contact.tsx'))
const Solutions = lazy(() => import('./components/Solutions.tsx'))

function AppContent() {
  return (
    <Router>
      <ScrollToTop />
      <ClickSpark
        sparkColor="var(--color-red)"
        sparkSize={12}
        sparkRadius={25}
        sparkCount={8}
        duration={400}
      >
        <div className="relative bg-[var(--color-bg-primary)] min-h-screen">

        {/* Animated vertical accent line — left */}
        <div className="fixed left-6 top-0 bottom-0 w-[1px] z-[50] pointer-events-none opacity-10 hidden lg:block animated-border" />
        {/* Animated vertical accent line — right */}
        <div className="fixed right-6 top-0 bottom-0 w-[1px] z-[50] pointer-events-none opacity-10 hidden lg:block animated-border" style={{ animationDelay: '-0.5s' }} />

        <Navbar />
        <main className="relative z-10 pt-[88px] min-h-screen flex flex-col">
          <Suspense fallback={<div className="min-h-screen flex items-center justify-center text-[var(--color-text)]">Loading...</div>}>
            <Routes>
              <Route path="/" element={<Home />} />
              
              {/* Additional Pages */}
              <Route path="/services" element={<Services />} />
              <Route path="/solutions" element={<Solutions />} />
              <Route path="/portfolio" element={<Portfolio />} />
              <Route path="/process" element={<Process />} />
              <Route path="/about" element={<WhyChooseUs />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/testimonials" element={<Testimonials />} />
              
              <Route path="/careers" element={<Careers />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/docs" element={<Documentation />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/privacy" element={<PrivacyPolicy />} />
            </Routes>
          </Suspense>
        </main>
        <Footer />
        </div>
      </ClickSpark>
    </Router>
  )
}

function App() {
  return (
    <ThemeProvider>
      <AppContent />
    </ThemeProvider>
  )
}

export default App
